import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=7b711619&scoped=true&lang=pug&"
import script from "./ProductCategoryList.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b711619",
  null
  
)

export default component.exports